import {
  getDepartment,
  patchDepartment,
  updateList,
} from '@vlabs/api/artemy/client';
import type { DepartmentId, ListId } from '@vlabs/api/artemy/model';

interface MoveListsToDepartmentParams {
  departmentId: DepartmentId;
  listIds: ListId[];
  targetDepartmentId: DepartmentId;
  keepViewPermission: boolean;
}

async function moveListsToDepartment({
  departmentId,
  listIds,
  targetDepartmentId,
  keepViewPermission,
}: MoveListsToDepartmentParams): Promise<void> {
  await Promise.all(
    listIds.map(async (listId) => updateList(listId, {
      owner_department: targetDepartmentId,
    })),
  );

  if (!keepViewPermission) {
    const department = await getDepartment(departmentId);

    await patchDepartment(departmentId, {
      lists: (department.lists ?? []).filter(({ list_id }) => !listIds.includes(list_id)),
    });
  }
}

export { moveListsToDepartment };
